/**
 * Represents a discrepancy between ordered and delivered quantities for a stock item.
 * @interface
 */
export interface PurchaseOrderDiscrepancy {
  /** The stock item code associated with the discrepancy. */
  stockItemCode: string;
  /** The stock item ID (SKU) associated with the discrepancy. */
  stockItemId: number;
  /** The quantity of the stock item that was ordered. */
  orderedQuantity: number;
  /** The quantity of the stock item that was delivered. */
  deliveredQuantity: number;
  /** Purchase order number. */
  purchaseOrderNumber: number;
  /** The Supplier comment on the purchase order item. */
  supplierComments: string;
}
